export const ML_EXPORTS_URL = {
  ROOT: "/ml-exports",
  REVIEW: "/ml-exports/review",
  CONFIGS: "/ml-exports/configs",
  RUNS: "/ml-exports/runs",
  RUN_DETAIL: "/ml-exports/runs/:runId",
} as const;
